module.exports = __webpack_public_path__ + "static/media/search-icon.e18761fb.svg";